/**
 * AUTO-GENERATED by scripts/generate-version.js - do not edit by hand.
 * Regenerated on every `npm run build` (see the "prebuild" script).
 */

export const APP_VERSION = '0.2.0';
export const BUILD_TIME = '2026-09-24T06:18:01.252Z';
export const GIT_COMMIT = 'e97dea0';
